import { render, staticRenderFns } from "./CreditNoteSale.vue?vue&type=template&id=3a848188"
import script from "./CreditNoteSale.vue?vue&type=script&lang=js"
export * from "./CreditNoteSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports